import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/HomeView',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },

  /**产品体系 */
  {
    path: '/productCenter',
    name: 'productCenter',
    redirect: {
      name: 'jsjg',
    },
    component: () => import('../views/productCenter/index.vue'),
    children: [{
        path: 'jsjg',
        name: 'jsjg',
        component: () => import('../views/productCenter/jsjg.vue')
      },
      {
        path: 'glpt',
        name: 'glpt',
        component: () => import('../views/productCenter/glpt.vue')
      },
      {
        path: 'sjpt',
        name: 'sjpt',
        component: () => import('../views/productCenter/sjpt.vue')
      },
    ]
  },

  /**解决方案 */
  {
    path: '/solution',
    name: 'solution',
    // redirect: {
    //   name: 'project',
    // },
    component: () => import('../views/solution/index.vue'),
    children: [{
        path: 'project',
        name: 'project',
        component: () => import('../views/solution/project.vue')
      },
      {
        path: 'budget',
        name: 'budget',
        component: () => import('../views/solution/budget.vue')
      },
      {
        path: 'Synergy',
        name: 'Synergy',
        component: () => import('../views/solution/Synergy.vue')
      },
      {
        path: 'business',
        name: 'business',
        component: () => import('../views/solution/business.vue')
      },
      {
        path: 'dataInfo',
        name: 'dataInfo',
        component: () => import('../views/solution/dataInfo.vue')
      },
      {
        path: 'Deposit',
        name: 'Deposit',
        component: () => import('../views/solution/Deposit.vue')
      },
    ]
  },
  {
    path: '/SuccessfulCases',
    name: 'SuccessfulCases',
    component: () => import('../views/SuccessfulCases/index.vue')
  },
  {
    path: '/SuccessfulCasesDetail',
    name: 'SuccessfulCasesDetail',
    component: () => import('../views/SuccessfulCases/detail.vue')
  },
  {
    path: '/SuccessfulCasesDetail2',
    name: 'SuccessfulCasesDetail2',
    component: () => import('../views/SuccessfulCases/detail2.vue')
  },
  {
    path: '/SuccessfulCasesDetail3',
    name: 'SuccessfulCasesDetail3',
    component: () => import('../views/SuccessfulCases/detail3.vue')
  },
  {
    path: '/SuccessfulCasesDetail4',
    name: 'SuccessfulCasesDetail4',
    component: () => import('../views/SuccessfulCases/detail4.vue')
  }, {
    path: '/SuccessfulCasesDetail5',
    name: 'SuccessfulCasesDetail5',
    component: () => import('../views/SuccessfulCases/detail5.vue')
  }, {
    path: '/SuccessfulCasesDetail6',
    name: 'SuccessfulCasesDetail6',
    component: () => import('../views/SuccessfulCases/detail6.vue')
  }, 
  {
    path: '/SuccessfulCasesDetail7',
    name: 'SuccessfulCasesDetail7',
    component: () => import('../views/SuccessfulCases/detail7.vue')
  },
  {
    path: '/SuccessfulCasesDetail8',
    name: 'SuccessfulCasesDetail8',
    component: () => import('../views/SuccessfulCases/detail8.vue')
  },
  {
    path: '/customer',
    name: 'customer',
    component: () => import('../views/customer/index.vue')
  },
  {
    path: '/AboutUs',
    name: 'AboutUs',
    component: () => import('../views/AboutUs/index.vue')
  }
]
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  routes
})

export default router